import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from '@core/services';
import { UserType } from '@core/interfaces';
import { BusinessRoutePaths } from '@core/configs/route-paths';

@Component({
  selector: 'app-external-auth-callback',
  templateUrl: './external-auth-callback.component.html',
  styleUrls: ['./external-auth-callback.component.css']
})
export class ExternalAuthCallbackComponent implements OnInit, OnDestroy {

  public isProcessing = true;
  private destroy$ = new Subject<void>();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    const status = this.route.snapshot.queryParamMap.get('status');
    const error = this.route.snapshot.queryParamMap.get('error');
    const redirect = this.route.snapshot.queryParamMap.get('redirect');

    if (error) {
      this.redirectToSignIn(error);
      return;
    }

    if (status !== 'success') {
      this.redirectToSignIn('external_login_failed');
      return;
    }

    this.authenticationService.refresh()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          if (!result?.success || !result?.user) {
            this.redirectToSignIn('login_failed');
            return;
          }

          const target = redirect ?? (result.user.userType === UserType.Business ? BusinessRoutePaths.root : '/');
          this.router.navigateByUrl(target || '/');
        },
        error: () => this.redirectToSignIn('login_failed')
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private redirectToSignIn(errorKey: string): void {
    this.isProcessing = false;
    this.router.navigate(['/sign-in'], { queryParams: { externalError: errorKey } });
  }
}
